import React, {Component} from "react";
import Tick from "./Ticker";
import country from '../assets/country.json';
import weight from '../assets/weight.json';

class RateOfChange extends Component {
  state = {
    loader: true,
    currency: 'USD',
    weightLoader: true,
    defaultWeight: 'o',
    page: 'default'
  }
  updateUrl = (val) => {
      fetch(`https://data-asg.goldprice.org/dbXRates/${val}`)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            items: result.items[0]
          });
        },
      )
  }
  componentDidMount = () => {
    var currency = this.state.currency

    if(localStorage.getItem(`${this.props.title}_default`) && JSON.parse(localStorage.getItem(`${this.props.title}_default`)).currency_ticker) {
      currency = JSON.parse(localStorage.getItem(`${this.props.title}_default`)).currency_ticker
      this.setState({
        currency: currency
      })
    }

    //default country filters on country pages
    if(!window.location.href.includes('gold-price-per') && !window.location.href.includes('silver-price-per')) {
      var data  = country.filter(item => window.location.href.includes(item.view_node)).map(item => {
        var currency = item.field_currency_symbol
        if(localStorage.getItem(`${this.props.title}_${item.field_currency_symbol}`) && JSON.parse(localStorage.getItem(`${this.props.title}_${item.field_currency_symbol}`)).currency_ticker) {
          currency = JSON.parse(localStorage.getItem(`${this.props.title}_${item.field_currency_symbol}`)).currency_ticker
        }
        this.setState({
          currency: currency,
          page: item.field_currency_symbol,
        })
        fetch(`https://data-asg.goldprice.org/dbXRates/${currency}`)
        .then((res) => res.json())
        .then((res) => {
          this.setState({
            items: res.items[0],
            loader: false
          })
        })
        return null;
      })
      if(data.length === 0) {
        currency = this.props.currency_ticker ? this.props.currency_ticker : currency
        if(this.props.currency_ticker && this.props.currency_ticker === 'CNY') {
          this.setState({
            currency: this.props.currency_ticker,
            page: "CNY",
            defaultWeight: 'k'
          })
        }
        fetch(`https://data-asg.goldprice.org/dbXRates/${currency}`)
        .then((res) => res.json())
        .then((res) => {
          this.setState({
            items: res.items[0],
            loader: false
          })
        })
      }
    }
    else if(window.location.href.includes('gold-price-per') || window.location.href.includes('silver-price-per') ) {
    //default weight filters on weight pages
      weight.filter(item => window.location.href.split("/").slice(-1)[0].includes(item.title.toLowerCase().replace(/ /g,"-")))
      .map(item => {
        var weig = "o"
        if(item.field_charts_def_gold_weight === "Kilo") {
            weig = "k"
        }
        else if(item.field_charts_def_gold_weight === "Gram") {
            weig = "g"
        }
        this.setState({
            weightLoader: false,
            defaultWeight: weig,
            page: weig
        })
        if(localStorage.getItem(`${this.props.title}_${weig}`) && JSON.parse(localStorage.getItem(`${this.props.title}_${weig}`)).currency_ticker) {
          currency = JSON.parse(localStorage.getItem(`${this.props.title}_${weig}`)).currency_ticker
          this.setState({
            currency: currency
          })
        }
        fetch(`https://data-asg.goldprice.org/dbXRates/${currency}`)
        .then((res) => res.json())
        .then((res) => {
          this.setState({
            items: res.items[0],
            loader: false
          })
        })
        return null;
      })
    }

    //runs every 10 seconds
    setInterval(() => {
      var currency = this.props.currency_ticker ? this.props.currency_ticker : this.state.currency
      fetch(`https://data-asg.goldprice.org/dbXRates/${currency}`)
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          items: res.items[0],
          loader: false
        })
      })
    }, 10000);
  }

  //set the currency
  setCurrency = (val) => {
      this.setState({
        currency: val
      })
      this.updateUrl(val)
  }
  render() {
    return (
      <div className="ticker-wrapper">
        {!this.state.loader ? <div><p className="hidden">{this.state.page}</p><Tick title = {this.props.title} page = {this.state.page} defaultWeight = {this.state.defaultWeight} defaultCurrency = {this.state.currency} currencyVal = {this.setCurrency} defaultValue={this.props.default} items={this.state.items} /></div> : <p>Loading...</p>}
      </div>
    )
  }

}

export default RateOfChange;